// extracted by mini-css-extract-plugin
export default {"btn":"GenTertiary_btn__hxtV2","btnalt":"GenTertiary_btnalt__BC1Lk","modal":"GenTertiary_modal__1-e2I","backdrop":"GenTertiary_backdrop__-DV2c"};